import script from "./PortfolioDetailsCompetencies.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioDetailsCompetencies.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioDetailsCompetencies.vue?vue&type=style&index=0&id=24115b8c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24115b8c"]])

export default __exports__